<template>
    <div class="marqueebox" ref="marqueeBox" @mouseenter="stop" @mouseleave="roll">
        <span ref="marqueeText" :style="{transform: 'translateX('+ left +'px)'}">{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: "marqueeBox",
        props:{
            text:{
                type: String,
                default: ''
            },
            times:{
                type: Number,
                default: 0
            }
        },
        data(){
            return{
                left:0,
                timer: null
            }
        },
        mounted() {
            setTimeout(() => {
                let boxW = this.$refs.marqueeBox.offsetWidth;
                this.left = boxW
                this.roll();
            }, this.times)
        },
        methods:{
            roll(){
                let boxW = this.$refs.marqueeBox.offsetWidth;
                let textW = this.$refs.marqueeText.offsetWidth;
                this.timer = setInterval(()=>{
                    if(-this.left > textW){
                        this.left = boxW
                    }
                    this.left = this.left - 1
                },20)
            },
            stop(){
                clearInterval(this.timer)
                this.timer = null
            }
        },
        beforedestroy() {
            this.stop();
        }
    }
</script>

<style lang="less" scoped>
    .marqueebox{
        width: 100%;
        height: 100%;
        overflow: hidden;
        white-space: nowrap;
        span{
            position: absolute;
            white-space: nowrap;
        }
    }
</style>
